import * as React from 'react';

import { mergeStyles, Tooltip, TooltipPosition } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';

import { IconType } from '../../../ui/icon/icon';
import { Region } from '../../../utils/regions';
import { Check as CheckIcon } from '../../standard/icons';

const styles = require('./bank.css');

const DEFAULT_TEXT_COLOR = '#121212';
const DEFAULT_BANK_COLOR = '#e4e4e4';

export interface IProps {
  tooltipPosition?: TooltipPosition;
  selectedRegion?: Region;

  id: number;
  title: string;
  gksList?: string[];
  icon?: IconType;
  color?: string;
  fullTitle?: string;
  textColor?: string;
  iconStyle?: React.CSSProperties;
  isDisabled?: boolean;
  rate?: string;
  initialInstallment?: number;
  maxLoanTerm?: number;
  minLoanTerm?: number;
  militaryMortgage?: boolean;
}

interface IState {
  hideTooltip: boolean;
  tooltipVisible: boolean;
}

export class Bank extends React.PureComponent<IProps, IState> {
  public state = {
    hideTooltip: false,
    tooltipVisible: false,
  };

  public render() {
    const { props } = this;
    const icon = props.icon ? <props.icon iconClassName={styles['logo']} style={props.iconStyle} /> : null;

    return (
      <article className={styles['bank']}>
        <header
          className={styles['header']}
          style={{
            backgroundColor: props.color || DEFAULT_BANK_COLOR,
            color: props.textColor || DEFAULT_TEXT_COLOR,
          }}
        >
          {props.title}
          {icon}
        </header>
        <div className={styles['info']}>
          {this.renderRate()}
          {this.renderInitialInstallment()}
          {this.renderMaxLoanTerm()}
          {this.renderMilitaryMortgage()}
          {/* <p className={styles['text']}>Без комиссии</p> */}
          {/* <p className={styles['text']}>С любым гражданством</p> */}
          {this.renderGKsCount()}
        </div>
      </article>
    );
  }

  private renderRate = () => {
    const { props } = this;

    if (!props.rate) {
      return null;
    }

    return (
      <div className={styles['rate-info']}>
        <span className={styles['rate-line']}>
          от&nbsp;<strong className={styles['rate']}>{props.rate}%</strong>
        </span>
        <span className={styles['rate-line']}>процентная&nbsp;ставка</span>
      </div>
    );
  };

  private renderInitialInstallment = () => {
    const { props } = this;

    if (!props.initialInstallment) {
      return null;
    }

    return (
      <p className={styles['text']}>
        Первоначальный взнос <strong>от {props.initialInstallment}%</strong>
      </p>
    );
  };

  private renderMaxLoanTerm = () => {
    const { props } = this;

    if (!props.maxLoanTerm) {
      return null;
    }

    return (
      <p className={styles['text']}>
        Срок кредита{' '}
        <strong>
          от {props.minLoanTerm} года до {props.maxLoanTerm} лет
        </strong>
      </p>
    );
  };

  private renderGKsCount = () => {
    const { props, state } = this;
    const gksList = props.gksList || [];
    const gksLength = gksList.length;

    if (gksLength <= 0) {
      return null;
    }

    const tooltipStyles = mergeStyles(
      styles['tooltip'],
      state.hideTooltip && styles['hidden'],
      state.tooltipVisible && styles['visible'],
    );

    return (
      <div
        className={styles['tooltip-wrapper']}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Tooltip
          position={this.props.tooltipPosition}
          tooltipStyles={tooltipStyles.className}
          tooltipContent={gksList.join(', ')}
        >
          <p className={styles['gks']}>
            {gksLength} {plural(gksLength, ['аккредитованный', 'аккредитованных', 'аккредитованных'])} ЖК
          </p>
        </Tooltip>
      </div>
    );
  };

  private renderMilitaryMortgage = () => {
    const { militaryMortgage } = this.props;

    if (!militaryMortgage) {
      return null;
    }

    return (
      <p {...mergeStyles(styles['text'], styles['military-mortgage'])}>
        <div>Доступна военная ипотека</div>
        <CheckIcon />
      </p>
    );
  };

  private handleMouseEnter = () => {
    this.setState({ tooltipVisible: true });
  };

  private handleMouseLeave = () => {
    // магия для тупых тултипов
    this.setState({ hideTooltip: true }, () =>
      setTimeout(
        () =>
          this.setState({
            hideTooltip: false,
            tooltipVisible: false,
          }),
        200,
      ),
    );
  };
}
